import fullPage from 'fullpage.js';

import 'fullpage.js/dist/jquery.fullPage.css';

export default fullPage;



/** WEBPACK FOOTER **
 ** ./src/fullPage.js
 **/